import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

export const OlvaPreset = definePreset(Aura, {
    components: {
        autocomplete: {
            root: {
                invalidBorderColor: 'var(--theme-focus-border-color)',
                focusBorderColor: 'var(--theme-focus-border-color)',
                hoverBorderColor: 'var(--theme-focus-border-color)'
            }
        },
        accordion: {
            colorScheme: {
                light: {
                    header: {
                        focusRing: {
                            color: 'var(--theme-focus-border-color)'
                        }
                    }
                }
            }
        },
        button: {
            colorScheme: {
                light: {
                    root: {
                        primary: {
                            focusRing: {
                                color: 'var(--theme-focus-border-color)'
                            }
                        },
                        secondary: {
                            focusRing: {
                                color: 'var(--theme-focus-border-color)'
                            }
                        }
                    }
                }
            }
        },

        checkbox: {
            root: {
                focusRing: {
                    color: 'var(--theme-focus-border-color)'
                }
            }
        },
        radiobutton: {
            colorScheme: {
                light: {
                    root: {
                        // checkedBackground: 'var(--theme-focus-border-color)',
                        focusRing: {
                            // color: 'var(--theme-focus-border-color)'
                        }
                    },
                    icon: {
                        // checkedColor: 'var(--theme-focus-border-color)'
                    }
                }
            }
        },
        tabs: {
            colorScheme: {
                light: {
                    // tablist: {
                    //     background: 'var(--tabs-tablist-bg)',
                    //     borderColor: 'var(--tabs-tablist-border)'
                    // },
                    tab: {
                        background: 'var(--theme-disable-color)',
                        padding: '14px 16px',
                        // hoverBackground: 'var(--tabs-tab-hover-bg)',
                        // activeBackground: 'var(--tabs-tab-active-bg)',
                        // color: 'var(--tabs-tab-color)',
                        // hoverColor: 'var(--tabs-tab-hover-color)',
                        // activeColor: 'var(--tabs-tab-active-color)',
                        // activeBorderColor: 'var(--theme-focus-border-color)',
                        focusRing: {
                            color: 'var(--theme-focus-border-color)'
                        }
                    }
                    // tabpanel: {
                    //     background: 'var(--tabs-panel-bg)',
                    //     color: 'var(--tabs-panel-color)'
                    // },
                    // activeBar: {
                    //     background: 'var(--tabs-active-bar)'
                    // }
                },
                dark: {
                    tablist: {
                        background: 'var(--tabs-tablist-bg)',
                        borderColor: 'var(--tabs-tablist-border)'
                    },
                    tab: {
                        background: 'var(--tabs-tab-bg)',
                        hoverBackground: 'var(--tabs-tab-hover-bg)',
                        activeBackground: 'var(--tabs-tab-active-bg)',
                        color: 'var(--tabs-tab-color)',
                        hoverColor: 'var(--tabs-tab-hover-color)',
                        activeColor: 'var(--tabs-tab-active-color)',
                        activeBorderColor: 'var(--tabs-tab-active-border)'
                    },
                    tabpanel: {
                        background: 'var(--tabs-panel-bg)',
                        color: 'var(--tabs-panel-color)'
                    },
                    activeBar: {
                        background: 'var(--tabs-active-bar)'
                    }
                }
            }
        },
        textarea: {
            root: {
                invalidBorderColor: 'var(--theme-focus-border-color)',
                focusBorderColor: 'var(--theme-focus-border-color)',
                hoverBorderColor: 'var(--theme-focus-border-color)',
                borderColor: 'var(--color-secondary-sutile)'
            }
        },
        inputtext: {
            root: {
                // focusBorderColor: 'var(--theme-focus-border-color)',
                // hoverBorderColor: 'var(--theme-focus-border-color)',
                // sm:{
                //     fontSize: '14px'
                // }
            }
        },
        toggleswitch: {
            root: {
                focusRing: {
                    color: 'var(--theme-focus-border-color)'
                }
            }
        }
    }
});
